import React from "react";
import { Link } from "components";
import "./Logo.scss";
import { LogoComponent } from "./LogoComponent";

interface LogoInterface {
  className?: string;
  isLinkHome?: boolean;
}

/**
 * Displays Logo SVG
 *
 * @param className Optional, if additional class needs to be passed
 * @param isLinkHome Boolean - if true will wrap svg in link to homepage, false will return svg only
 * @returns Logo SVG either in a link or not
 *
 */
export const Logo = ({ className = "", isLinkHome = true }: LogoInterface): JSX.Element => {
  return isLinkHome ? (
    <Link to="/" className={`logo ${className}`}>
      <LogoComponent />
    </Link>
  ) : (
    <LogoComponent className={`logo ${className}`} />
  );
};
